/** @jsx h */
import { h, Fragment, cloneElement, toChildArray } from 'preact';
import type { ComponentChildren, VNode } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { INTERNAL_EVENTS } from '../components/common/constants/events.cnst';
// Custom Hook
const useWidgetState = (hostIns: any) => {
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        // Subscribe to the disable widget event
        const handleDisableWidget = (disabled: boolean) => {            
            setIsDisabled(disabled);
        };

        hostIns.on(INTERNAL_EVENTS.DISABLE_WIDGET, handleDisableWidget);

        // Cleanup subscription
        return () => {
            hostIns.off(INTERNAL_EVENTS.DISABLE_WIDGET, handleDisableWidget);
        };
    }, [hostIns]);

    return isDisabled;
};

interface ActiveOrPassiveProps {
    children: ComponentChildren;
    hostIns: any;
}

export const ActiveOrPassive = ({ children, hostIns }: ActiveOrPassiveProps): VNode => {
    
    const isDisabled = useWidgetState(hostIns);

    const style = {
        opacity: isDisabled ? 0.5 : 1,
        pointerEvents: isDisabled ? 'none' : 'auto' as const
    };

    return (
        <Fragment>
        {toChildArray(children).map(child => 
            typeof child === 'object' ? cloneElement(child as VNode, {
                style: {
                    ...style,
                    ...(child as any).props?.style
                }
            }) : child
        )}
    </Fragment>
    );
};

